export enum AutoSendReport {
  EachReferenceComplete = 'Each Reference Complete',
  HalfReferencesComplete = '50%+ References Complete',
  AllReferencesComplete = 'All References Complete'
}
